import React, { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { StickyCTA } from './StickyCTA';
import { motion } from 'motion/react';
import { ConstellationEffect } from './ConstellationEffect';
import { TrialBanner } from './TrialBanner';
import { WebMcpProvider } from './WebMcpProvider';

const LiveChatWidget = React.lazy(async () => {
  const mod = await import('./LiveChatWidget');
  return { default: mod.LiveChatWidget };
});

export function Layout() {
  const [enableLiveChat, setEnableLiveChat] = useState(false);

  useEffect(() => {
    // Keep heavy chat + GenAI off the initial critical path.
    const enable = () => setEnableLiveChat(true);

    const w = window as any;
    if (typeof w.requestIdleCallback === 'function') {
      const id = w.requestIdleCallback(enable, { timeout: 2500 });
      return () => w.cancelIdleCallback?.(id);
    }

    const t = window.setTimeout(enable, 1800);
    return () => window.clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white font-sans text-gray-900 selection:bg-indigo-100 selection:text-indigo-900">
      <WebMcpProvider />
      <TrialBanner />
      <ConstellationEffect />
      <Navbar />
      <Suspense
        fallback={
          <div className="flex-grow pt-20 relative z-10">
            <div className="min-h-[70vh] w-full">
              <div className="container mx-auto px-4 md:px-6 pt-10">
                <div className="h-7 w-2/3 max-w-xl rounded bg-gray-100" />
                <div className="mt-4 h-5 w-1/2 max-w-lg rounded bg-gray-100" />
                <div className="mt-10 h-64 w-full rounded-2xl bg-gray-50 border border-gray-100" />
              </div>
            </div>
          </div>
        }
      >
        <motion.main
          initial={false}
          animate={{ opacity: 1 }}
          className="flex-grow pt-20 relative z-10"
        >
          <Outlet />
        </motion.main>
        <StickyCTA />
        {enableLiveChat ? (
          <Suspense fallback={null}>
            <LiveChatWidget />
          </Suspense>
        ) : null}
        <Footer />
      </Suspense>
    </div>
  );
}
